// extracted by mini-css-extract-plugin
export default {"tab":"_31bkkLh-xq","tab-item":"_238HdZdA-c","tabItem":"_238HdZdA-c","tab-item-narrow":"_2u0BW99XIQ","tabItemNarrow":"_2u0BW99XIQ","tab-item-disabled":"_3WN8b_ri_n","tabItemDisabled":"_3WN8b_ri_n","tab-item-default":"_162vwYJrjn","tabItemDefault":"_162vwYJrjn","tab-item-active":"_19NHQqv4Ph","tabItemActive":"_19NHQqv4Ph"};
    if(module.hot) {
      // 1633091709088
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  